import { useState } from 'react';
import { Columns, Column, breakpoints } from '@etg/wings';
import { useTranslation, useProperty, useSnowplowTracking } from '@eti/providers';
import { ConnectedInput } from '@eti/form';
import { constants, persistInputData } from '@eti/utils';
import { FIRST_NAME, LAST_NAME, MAX_CHARS } from '../../utils/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const columnWidth = {
  [breakpoints._0]: '4/4',
  [breakpoints._768]: '2/4'
};
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const renderInputs = (firstNameLabel, lastNameLabel, firstNamePlaceholder, lastNamePlaceholder, shouldForceCapitalize, handleSnowplowFirstNameOnChange, handleSnowplowLastNameOnChange, handleOnFirstNameBlur, handleOnLastNameBlur, isReadOnly, id) => [/*#__PURE__*/_jsx(Column, {
  width: columnWidth,
  children: /*#__PURE__*/_jsx(ConnectedInput, {
    autoCapitalize: "on",
    autoComplete: "given-name",
    autoCorrect: "off",
    className: MOUSE_FLOW_CLASS_NAMES,
    "data-testid": `traveler-firstName-${id}-input`,
    isReadOnly: isReadOnly,
    label: firstNameLabel,
    maxLength: MAX_CHARS,
    name: `${FIRST_NAME}-${id}`,
    onBlur: handleOnFirstNameBlur,
    onChange: handleSnowplowFirstNameOnChange,
    placeholder: firstNamePlaceholder,
    shouldForceCapitalize: shouldForceCapitalize,
    shouldMarkInputAsRequired: true,
    spellCheck: "false",
    validationRuleName: FIRST_NAME,
    warningRuleName: `${FIRST_NAME}-${id}`
  })
}, "1"), /*#__PURE__*/_jsx(Column, {
  width: columnWidth,
  children: /*#__PURE__*/_jsx(ConnectedInput, {
    autoCapitalize: "on",
    autoComplete: "family-name",
    autoCorrect: "off",
    className: MOUSE_FLOW_CLASS_NAMES,
    "data-testid": `traveler-lastName-${id}-input`,
    isReadOnly: isReadOnly,
    label: lastNameLabel,
    maxLength: MAX_CHARS,
    name: `${LAST_NAME}-${id}`,
    onBlur: handleOnLastNameBlur,
    onChange: handleSnowplowLastNameOnChange,
    placeholder: lastNamePlaceholder,
    shouldForceCapitalize: shouldForceCapitalize,
    shouldMarkInputAsRequired: true,
    spellCheck: "false",
    validationRuleName: LAST_NAME,
    warningRuleName: `${LAST_NAME}-${id}`
  })
}, "2")];
const FullName = _ref => {
  let {
    form,
    id,
    isReadOnly
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const {
    isSnowplowTrackingEnabled,
    sendTrackEvent
  } = useSnowplowTracking();
  const [firstNameHasChanged, setFirstNameHasChanged] = useState(false);
  const [lastNameHasChanged, setLastNameHasChanged] = useState(false);
  const showLastNameBeforeFirstName = p('IbeClient.ShowLastNameBeforeFirstName') || false;
  const shouldPersistData = p('IbeClient.TravelerDetails.PersistFormData.Enabled');
  const sendTrackEventID = id ? parseInt(id, 10) + 1 : 0;
  const handleSnowplowFirstNameOnChange = () => {
    if (isSnowplowTrackingEnabled && !firstNameHasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Passenger first name',
        value: sendTrackEventID
      });
      setFirstNameHasChanged(true);
    }
  };
  const handleSnowplowLastNameOnChange = () => {
    if (isSnowplowTrackingEnabled && !lastNameHasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Passenger last name',
        value: sendTrackEventID
      });
      setLastNameHasChanged(true);
    }
  };
  const handleOnFirstNameBlur = shouldPersistData ? event => persistInputData(form, `${FIRST_NAME}-${id}`)(event.target.value) : undefined;
  const handleOnLastNameBlur = shouldPersistData ? event => persistInputData(form, `${LAST_NAME}-${id}`)(event.target.value) : undefined;
  const inputs = renderInputs(t('TravelerForm.FirstName.Label'), t('TravelerForm.LastName.Label'), t('Input.FirstName.Placeholder'), t('Input.LastName.Placeholder'), p('BookingFlow.Inputs.Capitalize.Enabled'), handleSnowplowFirstNameOnChange, handleSnowplowLastNameOnChange, handleOnFirstNameBlur, handleOnLastNameBlur, isReadOnly, id);
  return /*#__PURE__*/_jsx(Columns, {
    spacing: 24,
    children: showLastNameBeforeFirstName ? inputs.reverse() : inputs
  });
};
export default FullName;
//# sourceMappingURL=FullName.js.map